function initBundle(){

  const wrapper = document.getElementById("bundle-wrapper");
  if(!wrapper) return;
  wrapper.innerHTML = "";

  fetch(bundleDataUrl)
    .then(res => res.json())
    .then(data => {

      data.bundles.forEach((bundle, index) => {

        // BADGE
        const badgeHTML = bundle.badge
          ? `<span class="bundle-badge" style="background:${bundle.badge.color}">
            ${bundle.badge.text}
          </span>`
          : "";


        // ------------------------------------------------ VARIANT SELECTORS ------------------------------------------------
        let variantsHTML = "";

        for (let i = 0; i < bundle.variants; i++) {
          variantsHTML += `
        <div class="variant-select">

          <div class="left">
            <img
              src="${data.variant_images.og}"
              width="24"
              height="20"
            >
            <span>1x YUMZY SUPERFOOD Gummies</span>
          </div>

          <div class="right">
            <div class="variant active" data-flavor="og">
              <img
                src="${data.variant_images.og}"
                width="24"
                height="20"
              >
              OG
            </div>

            <div class="variant" data-flavor="sours">
              <img
                src="${data.variant_images.sours}"
                width="24"
                height="20"
              >
              Sours
            </div>

          </div>

        </div>
        `;
        }


        // ------------------------------------------------ GIFT ITEMS ------------------------------------------------
        let giftsHTML = "";

        if (bundle.show_gifts) {
          giftsHTML = `
        <div class="bonus_crd">
          <div class="bg_heading">BONUSES INCLUDED:</div>
          <div class="cards_row">
            ${data.gifts.map(gift => `
              <div class="crd_col">
                <div class="img_cvr">
                  <img src="${gift.image}" width="64" height="64">
                  <p>${gift.title}</p>
                </div>
              </div>
            `).join("")}
          </div>
          <p class="ttl_amt">Total Bonus Value: $534.98</p>
        </div>
        `;
        }


        // ------------------------------------------------ RENDER CARD ------------------------------------------------
        const html = `
      <label class="bundle-card ${index === 0 ? 'active' : ''}" data-quantity="${bundle.variants}">

        <div class="bundle-header">
        
          <div class="left_col">
            <div class="radio_br">
              <span class="radio_bg"></span>
            </div>

            <div class="bundle-info">
              <h3>
                <input type="radio" name="bundle" ${index === 0 ? "checked" : ""}>
                ${bundle.title}
              </h3>
              <p>${bundle.supply}</p>
              <span class="per-serving">
                ${bundle.per_serving}
              </span>
            </div>
          </div>

          <div class="price">
            <div class="discount-badge-box">
            ${badgeHTML}
              <span class="discount discount-blue">
                ${bundle.discount}
              </span>
            </div>

            <div class="prc">
              <span class="old">${bundle.old_price}</span>
              <span class="new">${bundle.new_price}</span>
            </div>
          </div>

        </div>

        ${variantsHTML}
        ${giftsHTML}
      </label>
      `;
        wrapper.insertAdjacentHTML("beforeend", html);
      });

      /* ---------- ADD BUTTON AFTER LOOP ---------- */
      const checkoutButton = `
        <div class="checkout-button-box">
          <button class="checkout-button">
            Try Yumzy Risk Free
          </button>
        </div>
      `;

      wrapper.insertAdjacentHTML("beforeend", checkoutButton);

      // Set default bundle data
      setTimeout(() => {
        getActiveBundleData();
      }, 200);

      // Click event for Active State
      const cards = document.querySelectorAll(".bundle-card");

      cards.forEach(card => {
        card.addEventListener("click", function (e) {

          // ignore clicks from radio input
          if (e.target.tagName === "INPUT") return;

          // remove active
          cards.forEach(c => c.classList.remove("active"));

          // activate clicked
          this.classList.add("active");

          // Update the Details on Bundle Card selection
          getActiveBundleData()

          const radio = this.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;

          const quantity = this.dataset.quantity;
          console.log("Quantity:", +quantity);

        });
      });

      // Variant switch
      document.addEventListener("click", function (e) {

        const variant = e.target.closest(".variant");
        if (!variant) return;

        const parent = variant.closest(".variant-select");

        // remove active from siblings
        parent.querySelectorAll(".variant").forEach(v => {
          v.classList.remove("active");
        });

        // activate clicked variant
        variant.classList.add("active");

        // Update the Details on variant selection
        getActiveBundleData()

        // get flavor name
        const flavor = variant.innerText.trim();
        console.log("Active Flavor:", flavor);
      });

      const VARIANTS = {
        og: {
          1: 48943114223858,
          2: 48943166423282,
          3: 48943166783730
        },
        sours: {
          1: 48943114256626,
          2: 48943166456050,
          3: 48943166816498
        }
      }

      // Get Active Bundle Data
      function getActiveBundleData() {

        const activeBundle = document.querySelector(".bundle-card.active");
        if (!activeBundle) return;

        const quantity = +activeBundle.dataset.quantity;
        const items = [...activeBundle.querySelectorAll(".variant-select")]
          .slice(0, quantity)
          .map(row => {

            const activeVariant = row.querySelector(".variant.active");
            const flavor = activeVariant.innerText.trim().toLowerCase();

            const variantId = VARIANTS[flavor][quantity];

            return {
              id: variantId,
              quantity: 1
            };

          });

        const bundleData = {
          // quantity,
          items
        };
        console.log("bundleData:", bundleData);

        sessionStorage.setItem("selectedBundle", JSON.stringify(bundleData));
      }

      /* ---------------- CHECKOUT ---------------- */

      const DISCOUNTS = {
        1: "SUB-YUMZY-B1RV3",
        2: "SUBS-DISC-BAGS2RV3",
        3: "SUBS-DISC-BAGS3RV3"
      }

      const SELLING_PLAN = {
        1: "6514704626",
        2: "6514737394",
        3: "6514770162"
      }

      const checkoutBtn = document.querySelector(".checkout-button");
      if (!checkoutBtn) {
        console.error("Checkout button not found");
        return;
      }

      checkoutBtn.onclick = async function () {

        checkoutBtn.disabled = true;
        checkoutBtn.innerText = "Processing...";
        checkoutBtn.style.opacity = "0.7";
        checkoutBtn.style.cursor = "not-allowed";

        try {
        
          const bundle = JSON.parse(
            sessionStorage.getItem("selectedBundle")
          )
        
          if (!bundle || !bundle.items) {
            console.error("No bundle selected")
            return
          }
        
          const items = bundle.items
        
          const activeBundle = document.querySelector(".bundle-card.active")
          const selectedBundle = +activeBundle.dataset.quantity
          console.log("Cart Payload:", items)
        
          /* -------- SELLING PLAN -------- */
          const sellingPlan = SELLING_PLAN[selectedBundle]

          if (sellingPlan) {
            items.forEach(item => {
              item.selling_plan = sellingPlan
            })
          }

          console.log("Cart Payload:", items)

          /* --- Clear cart --- */
          await fetch("/cart/clear.js", { method: "POST" })
        
          /* --- Add items --- */
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ items })
          })
        
          if (!response.ok) {
            throw new Error("Cart API failed")
          }
          await response.json()
        
          /* --- Apply Discount --- */
          const discount = DISCOUNTS[selectedBundle]
          const url = `/discount/${discount}?redirect=/checkout`
          console.log("Redirect URL:", url)
        
          window.location.href = url
        
        } catch (error) {
          console.error("Checkout Error:", error)

          /* --- Re-enable button --- */
          checkoutBtn.disabled = false
          checkoutBtn.innerText = "Try Yumzy Risk Free"
          checkoutBtn.style.opacity = "1"
          checkoutBtn.style.cursor = "pointer"
        }
      
      }
    });
};

window.addEventListener("load", initBundle);